var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServefooterFahionInactivation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.17,
    height: 64.17,
    viewBox: "0 0 64.17 64.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_176",
    "data-name": "\\uD328\\uC2A4 176",
    d: "M1692.655,1004.939a32.085,32.085,0,0,0-32.085,32.085,32.085,32.085,0,0,0-32.085-32.085,32.085,32.085,0,0,0,32.085-32.085A32.086,32.086,0,0,0,1692.655,1004.939Z",
    transform: "translate(-1628.485 -972.854)",
    fill: "#8c8c8c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServefooterFahionInactivation);
export default __webpack_public_path__ + "static/media/servefooter_fahion_inactivation.c596670b3ad11ba7a9198599fbd4df04.svg";
export { ForwardRef as ReactComponent };